import { writable } from "svelte/store";

export const pmfilters = writable(
  JSON.parse(localStorage.getItem("pmfilters")) || {}
);

pmfilters.subscribe((val) =>
  localStorage.setItem("pmfilters", JSON.stringify(val))
);

export const damfilters = writable(
  JSON.parse(localStorage.getItem("damfilters")) || {}
);

damfilters.subscribe((val) =>
  localStorage.setItem("damfilters", JSON.stringify(val))
);

export const modelercallActivity = writable(
  JSON.parse(localStorage.getItem("modelercallActivity")) || {}
);
modelercallActivity.subscribe((val) =>
  localStorage.setItem("modelercallActivity", JSON.stringify(val))
);

export const openedPage = writable(false);
export const sortedAccessRights = writable({});

export const currentSelectedModel = writable({});
